<script lang="ts">
  import "../global.css";
  import { invalidateAll } from "$app/navigation";
  import { onMount } from "svelte";
  import { setNow, setTimeZone } from "../data/clock";
  import { initializeSettings } from "../data/settings";
  import { minutes } from "../support/dates";
  import { initializePersistence } from "../data/persistence";
  import Analytics from "./_analytics.svelte";
  import OfflineCaching from "../components/offline-caching.svelte";
  import ErrorDialog from "../components/error-dialog.svelte";
  import Meta from "./_meta.svelte";
  import Footer from "./_footer.svelte";
  import SystemClock from "../components/system-clock.svelte";
  import { setLanguage } from "../domain/locale";

  export let data;

  $: font = data.font;
  $: heraldMap = data.heraldMap;
  $: settings = data.settings;
  $: plausibleDomain = data.plausibleDomain;
  $: gtmContainerId = settings.gtmContainerId;
  $: gaMeasurementId = settings.gaMeasurementId;
  $: theme = settings.theme;

  // Set system clock shared by all components
  // TODO - for some reason we must use data.* for this property access
  setNow(data.now);
  setTimeZone(data.timeZone);
  setLanguage(data.language, data.settings);

  onMount(function () {
    initializePersistence();
    initializeSettings(settings);

    const interval = setInterval(invalidateAll, minutes(15));

    return () => {
      clearInterval(interval);
    };
  });
</script>

{#if data.inlineJavascript}
  {@html data.inlineJavascript}
{/if}

<OfflineCaching {heraldMap} />

<Meta {font} {settings} />

<SystemClock />

<Analytics {gtmContainerId} {gaMeasurementId} {plausibleDomain} />

<slot />

<Footer
  showSchedule={settings.showSchedule}
  showHome={settings.showHome}
  showMap={settings.showMap}
  {theme}
/>

<ErrorDialog />
